export const NAV_LINKS = [
  { id: "about", label: "ОБО МНЕ" },
  { id: "services", label: "УСЛУГИ" },
  { id: "portfolio", label: "РАБОТЫ" },
  { id: "contact", label: "КОНТАКТЫ" },
];

export const PORTFOLIO_PROJECTS = [
  {
    id: "01",
    slug: "kazferrogroup",
    title: "KazFerroGroup",
    subtitle: "Хондамир Юлдашев",
    category: "Видеограф",
    description:
      "Портрет предпринимателя и корпоративный ролик о металлургической компании из Шымкента.",
    image: "/videos/posters/kazferrogroup.jpg",
    video: "/videos/kazferrogroup.mp4",
  },
  {
    id: "02",
    slug: "amanat",
    title: "AMANAT",
    subtitle: "Керимбаева Наргиза",
    category: "Мобилограф",
    description:
      "Съёмка кандидата и партийного контента AMANAT для парламентских выборов Казахстана — вертикальный формат для социальных сетей.",
    image: "/videos/posters/amanat.jpg",
    video: "/videos/amanat.mp4",
  },
  {
    id: "03",
    slug: "kazferrogroup-adilet",
    title: "KAZFERROGROUP × ADILET",
    subtitle: "Отчётный ролик",
    category: "Видеограф",
    description:
      "Съёмка отчётного ролика для партии ADILET на территории ферросплавного завода KAZFERROGROUP.",
    image: "/videos/posters/kazferrogroup-reels.jpg",
    video: "/videos/kazferrogroup-reels.mp4",
  },
  {
    id: "04",
    slug: "everesthome",
    title: "Everest Home",
    subtitle: "Жилой комплекс",
    category: "Мобилограф",
    description:
      "Мобильная съёмка жилого комплекса — атмосферные кадры интерьеров и фасада.",
    image: "/videos/posters/everesthome.jpg",
    video: "/videos/everesthome.mp4",
  },
  {
    id: "05",
    slug: "taekwondo-shymkent",
    title: "Taekwondo Shymkent",
    subtitle: "Спортивный клуб",
    category: "Видеограф",
    description:
      "Динамичная съёмка тренировок и соревнований таэквондо-клуба в Шымкенте.",
    image: "/videos/posters/taekwondo.jpg",
    video: "/videos/taekwondo.mp4",
  },
  {
    id: "06",
    slug: "namaste-yoga-shymkent",
    title: "Namaste Yoga Shymkent",
    subtitle: "Йога-студия",
    category: "Мобилограф",
    description:
      "Атмосферный ролик студии йоги — плавные кадры практики и пространства.",
    image: "/videos/posters/namaste-yoga.jpg",
    video: "/videos/namaste-yoga.mp4",
  },
];

export const SERVICES = [
  {
    id: "01",
    icon: "video",
    title: "Коммерческие видео",
    description: "Рекламные ролики, имиджевые видео, обзоры товаров и услуг.",
  },
  {
    id: "02",
    icon: "home",
    title: "Съёмка недвижимости и строительных объектов",
    description: "Показываю пространство, архитектуру и детали, которые продают.",
  },
  {
    id: "03",
    icon: "rings",
    title: "Свадебные видео",
    description:
      "Сохраняю важные моменты вашего дня в красивой кинематографичной форме.",
  },
  {
    id: "04",
    icon: "megaphone",
    title: "SMM-контент",
    description:
      "Reels, Stories, Shorts и другой контент для социальных сетей, который вовлекает и увеличивает охваты.",
  },
  {
    id: "05",
    icon: "trending",
    title: "SMM-продвижение",
    description:
      "Анализ, стратегия, контент-план и еженедельные отчёты по результатам.",
  },
  {
    id: "06",
    icon: "youtube",
    title: "YouTube-видео",
    description: "Съёмка и монтаж контента для YouTube-каналов любой тематики.",
  },
  {
    id: "07",
    icon: "mic",
    title: "Подкасты",
    description:
      "Профессиональная съёмка подкастов с качественным звуком и картинкой.",
  },
  {
    id: "08",
    icon: "event",
    title: "Event",
    description:
      "Съёмка мероприятий, конференций, презентаций и других событий.",
  },
  {
    id: "09",
    icon: "instagram",
    title: "Instagram Reels",
    description:
      "Креативные вертикальные видео, которые привлекают внимание и продают.",
  },
];

export const STATS = [
  {
    icon: "years",
    value: "4+",
    title: "ГОДА ОПЫТА",
    description: "в создании видео контента",
  },
  {
    icon: "briefcase",
    title: "РАБОТАЮ С БРЕНДАМИ",
    description: "и строительными компаниями",
  },
  {
    icon: "camera",
    title: "СНИМАЮ НА",
    description: "iPhone 17 Pro Max и Sony FX3",
  },
  {
    icon: "laptop",
    title: "МОНТИРУЮ В",
    description: "MacBook в Premiere Pro и DaVinci Resolve",
  },
];

export const ABOUT_TECH = [
  {
    label: "СНИМАЮ НА:",
    value: "iPhone 17 Pro Max и Sony FX3",
  },
  {
    label: "МОНТИРУЮ ВИДЕО НА MACBOOK:",
    value: "Adobe Premiere Pro и DaVinci Resolve",
  },
];

export const ABOUT_USEFUL = [
  "Коммерческие видео",
  "Съёмка недвижимости и строительных объектов",
  "Контент для бизнеса и брендов",
  "SMM-контент и продвижение Instagram",
  "Свадебные видео и мероприятия",
];

export const ABOUT_META = [
  { label: "МЕСТОПОЛОЖЕНИЕ", value: "Казахстан" },
  {
    label: "СПЕЦИАЛИЗАЦИЯ",
    value: "Коммерческие проекты, недвижимость и социальные сети",
  },
  { label: "ПОСТПРОДАКШН", value: "DaVinci Resolve" },
  { label: "ОТКРЫТ ДЛЯ", value: "Коммерческих проектов и сотрудничества" },
];

export const CONTACTS = {
  whatsapp: {
    label: "WhatsApp",
    href: "https://wa.me/77756780371",
    display: "+7 775 678 0371",
  },
  instagram: {
    label: "Instagram",
    href: "https://www.instagram.com/assanbekov.ernar/?hl=ru",
    display: "@assanbekov.ernar",
  },
  email: {
    label: "Email",
    href: "mailto:assanbekov.yernar@mail.ru",
    display: "assanbekov.yernar@mail.ru",
  },
  youtube: {
    label: "YouTube",
    href: "https://www.youtube.com/@yernar.assanbekov",
    display: "YouTube-канал",
  },
};

export const IMAGES = {
  heroBg: "/images/yernar-hero.jpg",
  portrait:
    "https://images.unsplash.com/photo-1670411952195-fffeca152dd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjB2aWRlb2dyYXBoZXIlMjBkYXJrfGVufDB8fHx8MTc4NTg2Mzg3MXww&ixlib=rb-4.1.0&q=85",
};

export const SHOWREEL_VIDEO = "/videos/everesthome.mp4";
export const SHOWREEL_POSTER = "/videos/posters/everesthome.jpg";
